// in src/posts.js
import * as React from "react";
import {  
  useNotify,
} from "react-admin";
import Edit from "../../baseComponents/Edit";
import { FormWOrders } from "./FormWOrders";


export const WOrdersEdit = () => {
  const notify = useNotify();

  const onSuccess = () => {
    notify("resources.CalorieCoefficient.action.updated");
  };

  
  return (
    <Edit
       onSuccess={onSuccess}
    >
      <FormWOrders></FormWOrders>
    </Edit>
  );
};
